import $ from 'jquery'
import 'slick-carousel'
// import Plyr from 'plyr'
import {TweenLite} from 'gsap'

document.onreadystatechange = function() {
	switch (document.readyState) {
		case 'loading':
			// The document is still loading.

		break;

		case 'interactive':
			// The document has finished loading. We can now access the DOM elements.
			// But sub-resources such as images, stylesheets and frames are still loading.
			// Equivalent of document.ready

		break;

		case 'complete':
			// The page is fully loaded.
			// Equivalent of window.load
			// Fire all functions
			$app.menu();
			$app.inlineSvg('.isvg');
			$app.questions();
			$app.hideSiteButton();
			$app.modals();
			$app.validation();
			$app.likes();
			$app.slider();
			$app.player();
			$app.share();
			$app.accordion();

		break;
	}
};

// Resize event
window.addEventListener('resize', function(event){
	// Example
	// if ($app.wW() >= $app.breakpoints().small) {}
});

// Utilities and behaviours namespaced to $app
// use these functions by calling $app.method();
var $app = {
	// Allows you to query the window width against the breakpoints. These MUST match breakpoints
	// set in _vars.scss

	// Example
	//
	// if ($app.wW() >= $app.breakpoints().small) {
	//  code to run when the window hits large breakpoint
	// }
	//
	breakpoints: function() {
		obj = {
			'xsmall':	'460',
			'small': 	'640',
			'medium':	'768',
			'large':	'1024',
			'xlarge':	'1280',
			'xxlarge':	'1600'
		}

		return obj;
	},

	wW: function(){
		return window.innerWidth;
	},

	// Sets element heights to the same
	// Usually worth duplicating code in window.load and window.resize
	// Will automatically reset the height correctly on resize thanks to the line
	// .css({'height': 'auto'});
	// I usually try to use it with the class .js-height

	// Usage: $app.equalHeights('.js-height');

	// If you're using the same 'module' in multiple areas this will prevent it from
	// setting the height across all of them
	// var sameHeight = document.querySelectorAll(".js-sameheight");
	// sameHeight.forEach((e) => {
		// var children = e.querySelectorAll('.js-height');
		// $app.equalHeights(children)
	// });
	// });

	// $('.js-sameheight').each(function(){
	// 	var children = $(this).find('.js-height');
	//
	// 	$app.equalHeights(children);
	// })
	equalHeights: function(el) {
		var findElement = $(el);
		var tallest = 0;

		findElement.css({'height': 'auto'});

		// Loop over matching divs
		for(var i = 0; i < findElement.length; i++)
		{
			var ele = findElement[i];
			var eleHeight = ele.offsetHeight;
			tallest = (eleHeight>tallest ? eleHeight : tallest); /* look up ternary operator if you dont know what this is */
		}
		for(i = 0; i < findElement.length; i++)
		{
			findElement[i].style.height = tallest + 'px';
		}
	},


	// function for setting cookies
	setCookie: function(name,value,days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	},

	// function for getting cookies
	getCookie: function(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	},

	// function to erase a cookie
	eraseCookie: function(name) {
		document.cookie = name+'=; Max-Age=-99999999;';
	},

	// function to inline an img with an svg
	// Usage: $app.inlineSvg('.isvg');
	inlineSvg: function(selector) {
		document.querySelectorAll(selector).forEach(el => {
			const imgID = el.getAttribute('id');
			const imgClass = el.getAttribute('class');
			const imgURL = el.getAttribute('src');

			fetch(imgURL).then(data => data.text()).then(response => {
				const parser = new DOMParser();
				const xmlDoc = parser.parseFromString(response, 'text/html');
				let svg = xmlDoc.querySelector('svg');

				if (typeof imgID !== 'undefined') {
					svg.setAttribute('id', imgID);
				}

				if (typeof imgClass !== 'undefined') {
					svg.setAttribute('class', imgClass + ' replaced-svg');
				}

				svg.removeAttribute('xmlns:a');

				el.parentNode.replaceChild(svg, el);
			});
		});
	},

	// question show/hide behaviour
	questions: function() {

		// show/hide 'other' text fields
		document.querySelectorAll(`[data-other]`).forEach(el => {
			el.addEventListener('change', function(){
				textField = document.querySelector('#' + el.dataset.other)
				if(el.checked) {
					textField.classList.remove('hidden');
				} else {
					// remove the field content
					textField.value = ''
					textField.classList.add('hidden');
				}
			});

		});

		// show/hide questions based on responses to other questions

		// show
		document.querySelectorAll(`[data-show]`).forEach(el => {

			// Outer HTML function
			$.fn.outerHTML = function() {
				return $('<div />').append(this.eq(0).clone()).html()
			};


			if(el.nodeName === 'INPUT'){
				el.addEventListener('change', function(){
					// split the contents of the data-show attribute by comma
					const els = el.dataset.show.split(',');
					els.forEach(elId => {
						const section = document.querySelector('#el' + elId)
						// opting to check the checked value rather than just toggling
						// to prevent any issues with event bubbling
						// and the item being shown when it should be hidden
						if(section != null){
							if(el.checked) {
								if ($(el).hasClass('child-has-moved')) {
									// Just show the question as it's already been moved
									//console.log($(section))
									section.classList.remove('hidden');
									section.classList.add('show');
									section.parentElement.parentElement.classList.remove('hidden');
									section.parentElement.parentElement.classList.add('show');
								} else {
									//console.log(section)
									$(el).addClass('child-has-moved')
									// Show & Move question if it's a drug and not been moved yet
									if (el.id.split('-')[0] == 'el6448') { // magic number?
										section.classList.remove('hidden');
										section.classList.add('show');
										section.parentElement.parentElement.classList.remove('hidden');
										section.parentElement.parentElement.classList.add('show');
										//console.log('IT IS A DRUG')
										let target = el.getAttribute('data-show')
										let $targetQuestion = $(`[data-question-id=${target}]`)
										$targetQuestion.addClass('form__row--injected')
										let $targetQuestionHTML = $targetQuestion.outerHTML()
										$targetQuestion.remove()

										$(el).parent().append($targetQuestionHTML)
									} else {
										// Just show the child question where it is
										section.classList.remove('hidden');
										section.classList.add('show');
										section.parentElement.classList.remove('hidden');
										section.parentElement.classList.add('show');
									}
								}
							} else {
								//console.log(section)
								section.classList.add('hidden')
								section.classList.remove('show');
								let m = el.parentElement.querySelector('.form__row--injected')
								if(m){
									m.classList.add('hidden')
									m.classList.remove('show')
								}

								//section.parentElement.parentElement.classList.add('hidden');
								//section.parentElement.parentElement.classList.remove('show');

							}

							// check parent element to see if it contains any visible questions
							parent = section.parentElement;
							if(parent.querySelectorAll('.show').length){
								parent.classList.add('show');
								parent.classList.remove('hidden');
							} else {
								parent.classList.add('hidden');
								parent.classList.remove('show');
							}
						}
					})
				});
			} else if(el.nodeName === 'OPTION') {
				el.parentElement.addEventListener('change', function(){
					// split the contents of the data-show attribute by comma
					const selectElement = el.parentElement
					const options = selectElement.querySelectorAll('option')
					//console.log(options);
					// first hide anything that is referenced in the options for this select
					options.forEach(opt => {
						if(typeof(opt.dataset.show) != 'undefined'){
							const toHide = opt.dataset.show.split(',')
							toHide.forEach(elId => {
								const targetElement = document.querySelector('#el' + elId)
								if(targetElement != null){
									targetElement.classList.remove('show');
									targetElement.classList.add('hidden');
								}
							})
						}
					})

					// then show the required questions based on the selected option
					if(selectElement.options[selectElement.selectedIndex].dataset.show){
						const toShow = selectElement.options[selectElement.selectedIndex].dataset.show.split(',');
						toShow.forEach(elId => {
							const targetElement = document.querySelector('#el' + elId)
							if(targetElement != null){
								targetElement.classList.remove('hidden');
								targetElement.classList.add('show');

								targetElement.parentElement.parentElement.classList.remove('hidden');
								targetElement.parentElement.parentElement.classList.add('show');
							}
						})
					}
				});
			}



		});

		// hide
		document.querySelectorAll(`[data-hide]`).forEach(el => {
			el.addEventListener('change', function(){
				els = el.dataset.hide.split(',');
				section = document.querySelector('#el' + elId)
				// opting to check the checked value rather than just toggling
				// to prevent any issues with event bubbling
				// and the item being shown when it should be hidden
				if(section != null){
					if(el.checked) { // NEED TO CHECK IF ANY OTHER ITEMS ARE CHECKED
						section.classList.add('hidden');
						section.classList.remove('show');
					} else {
						section.classList.remove('hidden');
						section.classList.add('show');
					}

					// check parent element to see if it contains any visible questions
					parent = section.parentElement;
					if(parent.querySelectorAll('.show').length){
						parent.classList.add('hidden');
						parent.classList.remove('show');
					} else {
						parent.classList.add('show');
						parent.classList.remove('hidden');
					}
				}
			});
		});


		// text replacement for region
		const regionLabels = document.querySelector(`[name="message[region]"`);
		if(regionLabels){
			regionLabels.addEventListener('change', function(){
				val = document.querySelector(`[name="message[region]"`).value
				document.querySelectorAll('.js-regionText').forEach(el => {
					el.innerHTML = val;
				})
			})
		}

		// text replacement for person of concern
		const personLabels = document.querySelector(`[name="message[personofconcern]"`);
		if(personLabels){
			personLabels.addEventListener('change', function(){
				val = document.querySelector(`[name="message[personofconcern]"`).value
				document.querySelectorAll('.js-personText').forEach(el => {
					el.innerHTML = val;
				})
			})
		}

	},


	replaceText: function (selector, text, newText, flags) {
		var matcher = new RegExp(text, flags);
		var elems = document.querySelectorAll(selector).forEach(el => {
			el.innerHTML = el.innerHTML.replace(matcher, newText);
		});
	},


	hideSiteButton: function() {
		document.querySelectorAll('.js-hide-site').forEach(el => {
			el.addEventListener('click', function(e){
				document.querySelector('.js-mask').classList.add('show') // hide things quickly
				var randUrl = [
					'https://www.google.co.uk/search?q=cat+pictures&sclient=img',
					'https://www.google.co.uk/search?q=dog+pictures&sclient=img',
					'https://www.google.co.uk/search?q=nature+pictures&sclient=img',
					'https://news.bbc.co.uk',
					'https://uk.norton.com/internetsecurity-privacy-what-are-cookies.html'
				]
				window.location.href = randUrl[Math.floor(Math.random()*randUrl.length)]; // redirect somewhere
			})
		});

		document.querySelectorAll('.js-show-site').forEach(el => {
			el.addEventListener('click', function(e){
				e.preventDefault();
				document.querySelector('.js-mask').classList.remove('show')
			})
		});
	},

	modals: function() {
		const body = document.querySelector('body')

		const maskHTML = `<div class="modal__mask modal--show"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>`;

		document.querySelectorAll('[data-modal]').forEach(el => {
			el.addEventListener('click', function(e){

				e.preventDefault();

				var url = this.href;
				var target = this.dataset.modal;

				var modal = document.querySelector(target);
				modal.classList.add('modal--show')
				var mask = document.createElement('div');
				mask.innerHTML = maskHTML;
				document.body.appendChild(mask);

				body.classList.add('showing-modal')
			})
		})


		document.querySelectorAll('[data-close]').forEach(el => {
			el.addEventListener('click', function(e){
				e.preventDefault();
				var modal = el.parentElement
				var mask = document.querySelector('.modal__mask');

				modal.classList.remove('modal--show');
				body.classList.remove('showing-modal');
				mask.remove()
			})
		})
	},


	validation: function() {
		//on form submission
		const form = document.querySelector('#webfam-form');

		if(form){
			form.addEventListener('submit', function(e){
				// remove error messages
				document.querySelectorAll('.error').forEach(err => {
					err.remove();
				})

				var s2valid = false;
				const q2 = document.querySelector('#section933');

				//loop through s2 checkboxes to see if any are checked
				q2.querySelectorAll('[type=checkbox]').forEach(el => {
					if(el.checked){
						s2valid = true;
					}
				})

				if(s2valid == false){
					e.preventDefault();
					var legend = q2.querySelector('legend');
					var group = q2.querySelector('.form__checkbox-group');

					var message = document.createElement('p')
					message.innerHTML = 'Please choose at least one item from the list below';
					message.classList.add('error');

					legend.parentNode.insertBefore(message, legend.nextSibling)

				}
			})
		}

	},

	likes: function() {
		document.querySelectorAll('.js-feedback').forEach(el => {
			// hide the submit buttons since we want to
			el.querySelector('[type="submit"]').classList.add('visually-hidden');

			el.querySelector('[type="checkbox"]').addEventListener('click', function(e){

				// submit the form by regular means until I can get the ajax working
				el.submit();

				// submit the form via ajax - NOT WORKING
				const formInputs = el.getElementsByTagName("input");
				let formData = new FormData();
				for (let input of formInputs) {
					formData.append(input.name, input.value);
				}

				/*
				let xhr = new XMLHttpRequest();
				xhr.open(el.e, el.action);

				// request state change event
				xhr.onreadystatechange = function() {

				// request completed?
				if (xhr.readyState !== 4) return;

				if (xhr.status === 200) {
					// request successful - show response
					console.log(xhr.responseText);
				}
				else {
					// request error
					console.log('HTTP error', xhr.status, xhr.statusText);
				}
				};

				xhr.send();
				*/

				// using Fetch API
				/*
				fetch(el.action,
					{
						method: el.method,
						body: formData
					})
					.then(response => response.json())
					.then(response => {

						console.log(response.data.success)

					})
					.catch(error => console.log(error.message))
					.finally(() => console.log("Done"));
				*/

			})

		})
	},

	// Slider using Slick
	slider: function() {
		const $sliders = document.querySelectorAll('[data-slick]')
		const $header = $('.header')
		const $headerBtn = $('.header .btn')
		const darkThemes = [
			'red', 'purple', 'black', 'pink', 'orange',
		]

		// If they exist on the page, init them all using Slick
		if ($sliders.length) {
			$sliders.forEach(el => {
				$(el).slick({

					// Dot navigation config
					dots: true,
					dotsClass: 'slider__dots container',

					// Autoplay
					autoplay: true,
					autoplaySpeed: 4000,

					// Removing nav arrows
					arrows: false
				})

				// Setting the slider to be the same height
				$(el).on('setPosition', function () {
					$(this).find('.slick-slide').height('auto')

					let slickTrackHeight = $(this).find('.slick-track').height()
					$(this).find('.slick-slide').css('height', `${slickTrackHeight}px`)
				})
			})

			// Updating the header theme to reflect the next slide's theme if the hero slider is progressed
			$('[data-slick=hero]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
				let $nextSlide = $(this).find(`[data-slick-index=${nextSlide}]`)
				let nextTheme = $nextSlide.find('.hero').attr('data-theme')
				let nextHighlight = $nextSlide.find('.hero').attr('data-highlight')

				// console.log(nextTheme)

				if (!darkThemes.includes(nextTheme)) {
					$header.removeClass('header--light')
					$header.addClass('header--dark')
				} else {
					$header.addClass('header--light')
					$header.removeClass('header--dark')
				}

				$headerBtn.removeClass(function (index, css) {
					return (css.match (/\bbtn--\S+/g) || []).join(' ')
				})
				$headerBtn.addClass(`btn--${nextHighlight}`)
			})
		}
	},


	// Plyr
	player: function() {
		const $players = document.querySelectorAll('[data-player]')

		if ($players.length) {
			$players.forEach(el => {
				new Plyr(el, {
					settings: []
				})
			})
		}
	},


	// Menu
	menu: function() {
		const hamburger = document.querySelector('[data-hamburger]');
		const menuWrap = hamburger.closest('.container').querySelector('.header__nav')
		const activeClass = 'menu-is-active';

		hamburger.addEventListener('click', () => {
			if (menuWrap.classList.contains(activeClass)) {
				menuWrap.classList.remove(activeClass)
			} else {
				menuWrap.classList.add(activeClass)
			}
		})
	},

	// Share functionality
	share: function() {
		if ($('[data-share]').length > 0) {
			const $socialWindow = $('[data-share]')

			$socialWindow.on('click', function(e) {
				e.preventDefault()
				window.open(this.href, 'Social', 'width=800, height=600')
				return false
			})
		}
	},

	accordion: function() {
		const $accordions = $('[data-accordions]')
		if($accordions[0]) {
			let $accordionTitle = $('[data-accordion-title]')

			// Accordion trigger
			$accordionTitle.on('click', function(e) {
				const $targetAccordion = $(this).next()

				if ($(this).parent().prop('open')) {
					//console.log('already open, so just close it')
					closeAccordion($targetAccordion, $(this))
				} else {
					// closeAllAccordions()
					openAccordion($targetAccordion, $(this))
				}

			})

			// Open accordion function
			function openAccordion($target, $title) {
				TweenLite.set($target, {
					height: 'auto',
					visibility: 'visible'
				})
				TweenLite.from($target, 0.3, {height:0})
				$title.attr('aria-expanded','true')
			}


			// Close accordion function
			function closeAccordion($target, $title) {
				$title.attr('aria-expanded','false')
				$target.css({
					'height':'',
					'visibility':''
				})
			}

			function closeAllAccordions() {
				$accordionTitle.attr('aria-expanded','false')
				$('.accordion__body').css({
					'height':'',
					'visibility':''
				})
				$('.accordion').removeAttr('open')
			}

			closeAllAccordions()
		}
	}

} // end of $app
